import React from 'react';
import './modal.scss';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';
import { Modal as AntDModal } from 'antd';
const Modal = props => {
  const {
    visible,
    onCancel,
    footer = false,
    centered = true,
    destroyOnClose = true,
    closable = true,
    wrapClassName,
    maskClosable = true,
    title,
    children,
    onModalOpen,
    maskStyle,
    zIndex = 1000,
  } = props;
  const modalProps = {
    visible,
    onCancel,
    footer,
    centered,
    destroyOnClose,
    maskClosable,
    closable,
    wrapClassName: `hb-modal ${wrapClassName}`,
    zIndex,
  };
  if (onModalOpen) onModalOpen();
  if (maskStyle) modalProps.maskStyle = maskStyle;
  return (
    <AntDModal {...modalProps} closable={false}>
      {(title || closable) && (
        <div className="hb-modal--header">
          <div className="hb-modal--header--title">
            {title ? title : <span>&nbsp;</span>}
          </div>
          {closable && (
            <div className="hb-modal--header--close-icon" onClick={onCancel}>
              <Icon size={20} class="icon-common-close" />
            </div>
          )}
        </div>
      )}
      {children}
    </AntDModal>
  );
};

Modal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  footer: PropTypes.bool,
  centered: PropTypes.bool,
  destroyOnClose: PropTypes.bool,
  maskClosable: PropTypes.bool,
  closable: PropTypes.bool,
  wrapClassName: PropTypes.string,
  title: PropTypes.string,
  onModalOpen: PropTypes.func,
  maskStyle: PropTypes.object,
};

export default Modal;
